<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'PHARMACY_GROUP.PHARMACY_GROUPS_LIST' | translate"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource?.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddPharmacyGroup">
          <button
            (click)="createPharmacyGroup()"
            mat-raised-button
            matTooltip="Create new pharmacy group"
            color="primary"
            type="button"
          >
            <span class="svg-icon-md" translate="PHARMACY_GROUP.NEW_PHARMACY_GROUP">
              <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
              New Pharmacy Group
            </span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <button
          style="width: 200px !important"
          class="btn btn-sm btn-light-{{ getItemCssClassByStatus(searchIsActiveSelect) }} mr-4"
          (click)="toggleStatus($event)"
        >
          {{ getItemStatusString(searchIsActiveSelect) }} Pharmacies Groups
        </button>
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="lastName">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'PHARMACY.TABLE.NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let pharmacyGroup">
            <span
              [matTooltip]="canViewPharmacyGroup(pharmacyGroup) ? 'View Pharmacy Group' : null"
              [class.clickable]="canViewPharmacyGroup(pharmacyGroup)"
              (click)="viewPharmacyGroupDblclick(pharmacyGroup.id, pharmacyGroup)"
              >{{ pharmacyGroup.name }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PHARMACY.TABLE.NAME' | translate }}</mat-label>
              <input
                matInput
                [placeholder]="'PHARMACY.TABLE.NAME' | translate"
                [(ngModel)]="searchNameInput"
              />
              <button
                *ngIf="searchNameInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchNameInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'PHARMACY.TABLE.EMAIL' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let pharmacyGroup">{{ pharmacyGroup.email }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchEmail">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PHARMACY.TABLE.EMAIL' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchEmailInput"
                [placeholder]="'PHARMACY.TABLE.EMAIL' | translate"
              />
              <button
                *ngIf="searchEmailInput"
                matSuffix
                mat-icon-button
                (click)="searchEmailInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'PHARMACY.TABLE.PHONE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let pharmacyGroup" class="phone-hyper-style"
            >{{ pharmacyGroup.phone | phoneFormat }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchPhone">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PHARMACY.TABLE.PHONE' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchPhoneInput"
                [mask]="'(000) 000-0000'"
                [placeholder]="'PHARMACY.TABLE.PHONE' | translate"
              />
              <button
                *ngIf="searchPhoneInput"
                matSuffix
                mat-icon-button
                (click)="searchPhoneInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="fax">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'PHARMACY.TABLE.FAX' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let pharmacyGroup" class="phone-hyper-style"
            >{{ pharmacyGroup.fax | phoneFormat }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchFax">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PHARMACY.TABLE.FAX' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchFaxInput"
                [mask]="'(000) 000-0000'"
                [placeholder]="'PHARMACY.TABLE.FAX' | translate"
              />
              <button
                *ngIf="searchFaxInput"
                matSuffix
                mat-icon-button
                (click)="searchFaxInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'PHARMACY.TABLE.STATUS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let pharmacyGroup">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getItemCssClassByStatus(pharmacyGroup.is_active?.toString())
              }} label-inline text-center"
            >
              {{ getItemStatusString(pharmacyGroup.is_active?.toString()) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PHARMACY.TABLE.STATUS' | translate }}</mat-label>
              <mat-select
                [(value)]="searchIsActiveSelect"
                [placeholder]="'PHARMACY.TABLE.STATUS' | translate"
                (selectionChange)="handleStatusChange()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let pharmacyGroup">
            <ng-template ngxPermissionsOnly="canViewPharmacyGroup">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Pharmacy Group"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewPharmacyGroup(pharmacyGroup)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canEditPharmacyGroup">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Pharmacy Group"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editPharmacyGroup(pharmacyGroup.id)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canActivatePharmacyGroup">
              <button
                matTooltip="{{ 'TABLE.ACTIVATE_DEACTIVATE' | translate }} Pharmacy Group"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="updateStatusForPharmacyGroup(pharmacyGroup)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/update_icon2.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canSoftDeletePharmacyGroup">
              <button
                matTooltip="{{ 'TABLE.DELETE' | translate }} Pharmacy Group"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="deletePharmacyGroup(pharmacyGroup)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>

